import axios from 'axios';
import store from '../store';
export default {
    namespaced: true,

    state: {
        idmodal: '',
        descripcionmodal: '',
        banderamodal: null,
        marca: "",
        marcas: ""


    },
    mutations: {
        LoadProductos(state, buscar) {
            //let aux = [];
            state.marca = state.marcas;


            let aux = state.marcas.filter((x) => x["nombremarca"].toUpperCase().includes(buscar.toUpperCase()),);

            if (buscar == "") {
                state.marca = state.marcas;
            } else {
                state.marca = aux;

            }
        },



        async cargardatosmarcas(state) {

            state.marcas = []
            var token = store.state.numero;
            await axios
                .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/marcas", {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                    },
                })
                .then((response) => {
                    state.marcas = response.data.data;


                });
            state.marca = state.marcas
        },

        cambio(state, descripcion) {
            state.descripcionmodal = descripcion

        },
        agregartable(state) {

            //      this.descripcionmodal = descripcion
            var token = store.state.numero;
            var datos = {
                nombremarca: state.descripcionmodal
            };
            this.banderamodal = store.state.banderamodal



            var datosfalso = state.idmodal;

            if (this.banderamodal === true) {


                axios

                    .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/marcas", datos, {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        let tokenn = response.data.token;
                        //this.respuesta = <z<
                        this.token = tokenn;


                    })

                    .catch((e) => {
                        console.log(e);
                    });
            } else {

                axios

                    .post(
                        "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/marcas/UpdateReg/" +
                        datosfalso,
                        datos,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((response) => {
                        let tokenn = response.data.token;
                        //this.respuesta = <z<
                        this.token = tokenn;

                    })

                    .catch((e) => {
                        console.log(e);
                    });
            }

        },


        datosmodal(state, api) {

            state.idmodal = api.idmarca,
                state.descripcionmodal = api.nombremarca

        },



        async eliminar(state, api) {
            var token = store.state.numero
            let eliminar = api;


            await axios
                .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/marcas/DeleteReg/" + eliminar,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + token,
                        },
                    })


                .then((response) => {
                    let tokenn = response.data.token;
                    state.datoeliminar = tokenn

                })

                .catch((e) => {
                    console.log(e);
                });



        },



    },
    actions: {

    },
    getters: {


    },






}